import ResumeItem from "@/common/components/ResumeItem";
import { useFormContext, useWatch } from "react-hook-form";
import { checkinEntryOptions } from "../../../../constants/directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant";
import { CheckinEntryValidationSchema } from "../../../../schemas/maintenanceForwardingDirectiveSteps.schema";
import { MaintenanceForwardingsCheckinEntryStepOptions } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepHeader from "../../../CreateForwardingDirectiveEntryFormStepHeader";

const CheckinEntryAutoEntryCompleted = () => {
  const {
    control,
  } = useFormContext<CheckinEntryValidationSchema>();

  const {
    checkin_entry_attributes: watchCheckinEntryAttributes,
  } = useWatch({
    control,
  });

  const watchResponsible = watchCheckinEntryAttributes?.responsible;

  const autoEntryOption = checkinEntryOptions[MaintenanceForwardingsCheckinEntryStepOptions.AutoEntry];

  return (
    <div className="flex flex-col gap-4">
      <CreateForwardingDirectiveEntryFormStepHeader
        title={autoEntryOption.title}
        description={autoEntryOption.description}
      />

      <div className="flex flex-col gap-2">
        <div>
          <ResumeItem
            label="Usuário responsável pelo transporte/confirmação de retirada"
            value={(watchResponsible?.label as string | JSX.Element) || '--'}
            className="text-sm"
          />
        </div>
      </div>
    </div>
  );
}

export default CheckinEntryAutoEntryCompleted;
